import { SUBMITTED_BID_STATUSES } from '@/features/bidding/constants'
import type { PtuForTheOfferVolumeDataGrid } from '@/features/bidding/types/bid'
import type { BidHistory } from '@/features/bidding/types/bidHistory'

export function getPtusForTheDataGridRowsUsingCapacityBid(
  ptus: PtuForTheOfferVolumeDataGrid[],
  capacityBidOnThisDay: BidHistory | undefined,
  volumeUnit: string,
): PtuForTheOfferVolumeDataGrid[] {
  // Get the latest capacity bid with accepted or offered status for offered/accepted volume (do not include DRAFT)
  const latestCapacityBid = capacityBidOnThisDay?.bids.findLast((bid) => SUBMITTED_BID_STATUSES.includes(bid.status))

  const capacityPtusCount = latestCapacityBid?.ptus.length ?? 0
  const ptusCount = ptus.length

  // The repeat factor is necessary because we might have different numbers of ptus between energy and capacity bids.
  const repeatFactor = capacityPtusCount > 0 ? Math.floor(ptusCount / capacityPtusCount) : 0

  return ptus.map((ptu, index) => {
    const indexToUse = repeatFactor > 0 ? Math.floor(index / repeatFactor) : 0

    return {
      ...ptu,
      offeredCapacityVolume: {
        quantity: latestCapacityBid?.ptus[indexToUse]?.offeredVolume.quantity ?? 0,
        unit: volumeUnit,
      },
      acceptedCapacityVolume: {
        quantity: latestCapacityBid?.ptus[indexToUse]?.acceptedVolume?.quantity ?? 0,
        unit: volumeUnit,
      },
    }
  })
}
